module.exports = __webpack_public_path__ + "static/media/belize.59fc7077.jpg";